<template>
  <div class="orgmanagerDetail">
    <div class="titleWrap">
      <div class="setTitle">{{ orgmanagerName }}</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/orgmanager' }">物业保洁列表</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="clearfix"></div>
    </div>
    <div class="contentWrap">
      <div class="infoWrap">
        <div class="infoHeader">基本信息</div>
        <div class="infoDiv">
          <span class="infoTitle">用户姓名：</span>
          <span class="infoContent">{{ orgmanagerName }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">身份证号：</span>
          <span class="infoContent">{{ orgmanagerCode }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">性别：</span>
          <span class="infoContent">{{ sex }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">联系电话：</span>
          <span class="infoContent">{{ phone }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">用户类型：</span>
          <span class="infoContent">{{ orgmanagerTypeValue }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">注册时间：</span>
          <span class="infoContent">{{ registrationTime }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">备注：</span>
          <span class="infoContent">{{ remark }}</span>
        </div>
      </div>
    </div>
    <el-main class="tableWrap">
      <div class="tableTitle">区域列表</div>
      <div class="clearfix"></div>
      <el-table :data="areaAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :align="align"></el-table-column>
        <el-table-column prop="building" label="楼栋" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.building }}栋
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单元" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.unit }}单元
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total" :total="areaTotal"></el-pagination>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'OrgmanagerDetail',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      myLocation: window.location.origin, // 当前域名
      setMinTime: { // 日期大于当前
        disabledDate: time => {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      villageId: '', // 小区Id
      villageCode: '', // 小区号
      orgmanagerId: '', // 用户Id
      orgmanagerName: '', // 用户姓名
      orgmanagerCode: '', // 身份证号
      sex: '', // 性别
      phone: '', // 联系电话
      orgmanagerType: '', // 用户类型
      orgmanagerTypeValue: '', // 用户类型展示
      registrationTime: '', // 注册时间
      remark: '', // 备注
      areaAttr: [], // 区域列表
      areaTotal: 0 // 区域总数
    }
  },
  mounted () {
    // 小区Id
    this.villageId = this.$route.query.villageId
    // 用户Id
    this.orgmanagerId = this.$route.query.id
    // 用户姓名
    this.orgmanagerName = decodeURI(decodeURI(this.$route.query.name))
    // 获取用户基本信息
    this.$http.get(this.$api.orgmanager_info_detail, {
      params: {
        id: this.orgmanagerId
      }
    }).then((res) => {
      let data = res.data

      if (data.data.success) {
        this.orgmanagerName = data.data.data.name
        this.orgmanagerCode = data.data.data.idCard
        this.phone = data.data.data.phone
        if (data.data.data.sex === 0) {
          this.sex = '女'
        }
        if (data.data.data.sex === 1) {
          this.sex = '男'
        }
        this.orgmanagerType = 4
        this.orgmanagerTypeValue = '物业保洁'
        this.registrationTime = data.data.data.createDate.substr(0, 4) + '-' + data.data.data.createDate.substr(5, 2) + '-' + data.data.data.createDate.substr(8, 2)
        this.remark = this.$null(data.data.data.remark)
      } else {
        this.$message({
          type: 'error',
          message: data.data.errMsg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取区域列表
    this.getAreaList()
  },
  methods: {
    getAreaList () {
      this.$http.get(this.$api.orgmanager_info_detail, {
        params: {
          id: this.orgmanagerId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.areaAttr = data.data.data.detailDtos
          this.areaTotal = data.data.data.detailDtos.length
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getSex (val) {
      switch (val) {
        case 0:
          return '女'
        case 1:
          return '男'
      }
    },
    notData (str) {
      return this.$null(str)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.orgmanagerDetail
  box-sizing border-box
  padding 80px 0 20px 20px
  width 100%
  min-height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .el-breadcrumb
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 12px
  .contentWrap
    box-sizing border-box
    margin-top 20px
    padding-right 20px
    .infoWrap
      box-sizing border-box
      padding 20px
      width 100%
      height 300px
      background #fff
      box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
      border-radius 4px
      .infoHeader
        line-height 20px
        font-size 16px
        font-weight bold
        color #333
      .infoDiv
        margin-top 16px
        line-height 18px
        font-size 14px
        .infoTitle
          display inline-block
          width 84px
          color #666
          text-align right
          vertical-align top
        .infoContent
          display inline-block
          color #333
          vertical-align top
      .notImage
        margin-top 18px
        width 96px
        height 96px
        line-height 96px
        font-size 12px
        color #999
        text-align center
        background-image url('./no_pic.png')
        background-repeat no-repeat
        background-size 100% 100%
      .photo
        display inline-block
        margin-top 18px
        margin-left 8px
        &:first-of-type
          margin-left 0
  .tableWrap
    margin-top 20px
    margin-right 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .tableTitle
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 16px
      color #333
    .addBtn
      float right
      margin-right 20px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
        .userType
          display inline-block
          width 16px
          height 16px
          background-repeat no-repeat
          background-size 100% 100%
          vertical-align sub
          &.owner
            background-image url('./owner.png')
          &.family
            background-image url('./family.png')
          &.tenant
            background-image url('./tenant.png')
          &.property
            background-image url('./property.png')
        .autho
          display inline-block
          width 10px
          height 10px
          border-radius 50%
          &.open
            background-color #60ACFC
          &.close
            background-color #ccc
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        .el-select, .el-input, .el-date-editor
          width 240px
</style>



// WEBPACK FOOTER //
// src/components/user/orgmanagerDetail.vue